import {AnimationAction, AnimationActionEnum, AnimationState} from "./types";
import {ICoords} from "../../../models/animations/ICoords";

const initialState: AnimationState = {
    showUnitAttack: {tableKey: null, side: null, damageToEnemy: false},
    showMiddleware: {tableKey: null, side: null},
    showHpChange:{side:null, value:null},
    showUnitADChange:{side:null, attackValue:null, hpValue:null, position:null},
    showPlayUnitHover:[false,false,false,false,false],
    coords: {} as ICoords
}

export default function authReducer(state = initialState, action: AnimationAction): AnimationState {
    switch (action.type) {
        case AnimationActionEnum.SET_SHOW_UNIT_ATTACK:
            return {...state, showUnitAttack: action.payload}
        case AnimationActionEnum.SET_SHOW_MIDDLEWARE:
            return {...state, showMiddleware: action.payload}
        case AnimationActionEnum.SET_SHOW_HP_CHANGE:
            return {...state, showHpChange: action.payload}
        case AnimationActionEnum.SET_SHOW_UNIT_AD_CHANGE:
            return {...state, showUnitADChange: action.payload}
        case AnimationActionEnum.SET_PLAY_UNIT_HOVER:
            return {...state, showPlayUnitHover: action.payload}
        case AnimationActionEnum.SET_COORDS:
            return {...state, coords: action.payload}
        default:
            return state;
    }
}